import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { RestClientPaged } from '@elderbyte/ngx-starter'
import { environment } from '../../../../../environments/environment'
import { WorkStationType } from './work-station-type'

@Injectable({
  providedIn: 'root',
})
export class WorkStationTypeService extends RestClientPaged<WorkStationType, string> {
  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const http = inject(HttpClient)

    super(environment.apiPath + '/work-stations/types', http, {
      idField: 'id',
    })
  }
}
